import { RouteProps } from "react-router";
import { UserRole } from "../types/user";

const routes = (role: UserRole): RouteProps[] =>
  require(`./${role.toLowerCase()}`).default;
export default routes;
